import React, { Component } from "react";
import configData from "../config.json";
import "./Charts.css";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Drilldown from "highcharts/modules/drilldown";

// Initialize Drilldown module
if (typeof Drilldown === "function") {
  Drilldown(Highcharts);
} else if (typeof Drilldown.default === "function") {
  Drilldown.default(Highcharts);
}
class Test extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartData: [],
      drillDownData: [],
      selectedChart: "pie", // Default chart type
    };
  }

  componentDidMount() {
    this.fetchChartData();
  }

  fetchChartData = () => {
    // Use proper authentication like other components
    const formData = new FormData();
    formData.append("sId", sessionStorage.getItem("sessionId"));
    formData.append("uId", sessionStorage.getItem("uId"));
    
    fetch(configData.api_url + "C_Widgetdefinition/drilldown", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data && data.status === "success") {
          const chartData = data.chart_data;
          const drillDownData = data.drilldown_data;
          this.setState({
            chartData,
            drillDownData,
          });
        } else {
          console.error("API returned error:", data.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching chart data:", error);
        // Set empty data to prevent render errors
        this.setState({
          chartData: [],
          drillDownData: [],
        });
      });
  };

  render() {
    const { chartData, drillDownData, selectedChart } = this.state;

    const chartOptions = {
      chart: {
        type: selectedChart, // Change dynamically
        backgroundColor: "#f9f9f9",
      },
      title: {
        text: "Office Sales Distribution",
        style: { color: "#333", fontSize: "18px" },
      },
      tooltip: {
        pointFormat: "<b>{point.y}</b>",
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: true,
            format: "<b>{point.name}</b>: {point.y}",
          },
        },
        bar: {
          dataLabels: {
            enabled: true,
          },
        },
        line: {
          dataLabels: {
            enabled: true,
          },
          enableMouseTracking: true,
        },
      },
      series: [
        {
          name: "Offices",
          colorByPoint: true,
          data: chartData,
        },
      ],
      drilldown: {
        series: drillDownData,
      },
    };

    return (
      <div
        style={{
          maxWidth: "800px",
          width: "90%",
          margin: "20px auto",
          textAlign: "center",
          background: "#fff",
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
        }}
      >
        <h2 style={{ color: "#333" }}>Drill-Down Chart</h2>

        {/* Dropdown to Select Chart Type */}

        <HighchartsReact
          highcharts={Highcharts}
          options={chartOptions}
          containerProps={{
            style: { width: "100%", height: "400px" }
          }}
        />
      </div>
    );
  }
}

export default Test;
